<script>
    export default {
        props: {
            'disabled': {
                type: Boolean,
                default: false
            },
            'classes': {
                type: String,
                default: ''
            },
            'checked': {
                type: Boolean,
                default: false
            },
            'name': {
                type: String,
                default: ''
            },
            'textBefore': {
                type: Boolean,
                default: true
            },

        },
        data() {
            return {
                value: null
            }
        },
        beforeMount() {
            this.value = this.checked
        },
        mounted() {
            this.$emit('input', this.value)
        },
        watch: {
            value(val) {
                this.$emit('input', val)
            },
            checked(val) {
                this.value = val
            }
        },
        methods: {
            change(obj, value) {
                this.$emit('change', obj, value);
            }
        }
    }
</script>
<template>
    <div class="d-flex align-items-start" :class="{ 'label-first justify-content-between': textBefore }">
        <label class="switch no-shrink" :class="classes">
            <input type="checkbox" class="form-check-input" :checked="checked" :name="name"
                   :disabled="disabled" v-model="value" @change.stop="change(value)">
            <span class="slider round"></span>
        </label>
        <slot></slot>
    </div>
</template>
<style scoped lang="scss">
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {display:none;}

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .label-first {
        > .switch {
            order: 2;
        }
        &:last-child {
            order: 1;
        }
    }
</style>




// WEBPACK FOOTER //
// resources/js/components/form/SwitchButton.vue